module.exports = __webpack_public_path__ + "static/media/products.797b3b51.svg";